import styled from 'styled-components';

export const Block = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
`;
